import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const entryList = style({
  display: "grid",
  gap: vars.space.xs,
  paddingTop: vars.space.xs,
});

export const listItem = style({
  padding: vars.space.xs,
  selectors: {
    "&:hover": {
      backgroundColor: vars.colors.surfaceVariant,
    },
  },
});
